"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pieve-di-bono-prezzo": {
    "808dfb30": [{
      "hkey": "bcecb436",
      "slug": "pieve-di-bono-prezzo",
      "name": "Pieve di Bono-Prezzo",
      "primary": true,
      "skipSearch": false
    }],
    "boniprati": [{
      "hkey": "bcecb436",
      "slug": "pieve-di-bono-prezzo",
      "name": "Pieve di Bono-Prezzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "205bb9ac": [{
      "hkey": "bcecb436",
      "slug": "pieve-di-bono-prezzo",
      "name": "Pieve di Bono-Prezzo",
      "primary": true,
      "skipSearch": false
    }],
    "cistel": [{
      "hkey": "bcecb436",
      "slug": "pieve-di-bono-prezzo",
      "name": "Pieve di Bono-Prezzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dd323f98": [{
      "hkey": "bcecb436",
      "slug": "pieve-di-bono-prezzo",
      "name": "Pieve di Bono-Prezzo",
      "primary": true,
      "skipSearch": false
    }],
    "dos": [{
      "hkey": "bcecb436",
      "slug": "pieve-di-bono-prezzo",
      "name": "Pieve di Bono-Prezzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "410c34bc": [{
      "hkey": "bcecb436",
      "slug": "pieve-di-bono-prezzo",
      "name": "Pieve di Bono-Prezzo",
      "primary": true,
      "skipSearch": false
    }],
    "pieve-di-bono": [{
      "hkey": "bcecb436",
      "slug": "pieve-di-bono-prezzo",
      "name": "Pieve di Bono-Prezzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0ee9db59": [{
      "hkey": "e24c94e9",
      "slug": "creto",
      "name": "Creto",
      "primary": true,
      "skipSearch": false
    }],
    "strada": [{
      "hkey": "e24c94e9",
      "slug": "creto",
      "name": "Creto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pieve-di-bono-prezzo"
    }]
  }
};
exports["default"] = _default;